import { render, staticRenderFns } from "./AiRouteMap.vue?vue&type=template&id=5b504a8e"
import script from "./AiRouteMap.vue?vue&type=script&lang=js"
export * from "./AiRouteMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports